<template>
    <div>
        <div v-if="showMap">
            <a-row>
                <a-col :span="3">
                    <a-button type="primary" @click="goBack">
                        返回
                    </a-button>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    查询时间
                </a-col>
                <a-col :span="4">
                    <my-date :date-value.sync="startDt" :placeholder="'开始时间'"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="4">
                    <my-date :date-value.sync="endDt" :placeholder="'结束时间'"/>
                </a-col>
                <a-col :span="4">
                    <a-button type="primary" @click="selectData">
                        查询
                    </a-button>
                </a-col>
            </a-row>
            <a-row>
                <a-spin :spinning="spinning">
                    <a-col :span="17">
                        <baidu-map class="map"
                                   :center="trCenter"
                                   :zoom="16"
                                   :scroll-wheel-zoom="true">
                            <bm-polyline :path="trajectory.deviceLocations"
                                         stroke-color="blue"
                                         :stroke-opacity="0.5"
                                         :stroke-weight="10"/>
                            <bm-marker :position="trajectory.device">
                                <bm-label :content="trajectory.carNo" :labelStyle="{color: 'red', fontSize : '12px'}"
                                          :offset="{width: 0, height: 30}"/>
                            </bm-marker>
                        </baidu-map>
                    </a-col>
                    <a-col :span="7">
                        <a-table :columns="columnsChildren"
                                 :data-source="trajectory.tbCounts"
                                 bordered
                                 size="small"
                                 :pagination="false"
                                 rowKey="id"/>
                        <div class="count">
                            <a-timeline mode="left" style="margin-top: 20px;width: 90%">
                                <a-timeline-item v-for="item in trajectory.alarmAndEvents"
                                                 :key="item.id"
                                                 style="left: 10px;text-align: left;"
                                                 :color="item.type === '告警'?'red':'green'">
                                    <div class="dv"
                                         :style="item.type === '告警'?'background-color: OrangeRed;':'background-color: LightGreen;'">
                                        <p style="margin-left: 20px;margin-top: 10px">{{item.createDt}}</p>
                                        <p style="margin-left: 20px">{{item.name}}</p>
                                        <p style="margin-left: 20px">{{item.msg}}</p>
                                    </div>
                                </a-timeline-item>
                            </a-timeline>
                        </div>
                    </a-col>
                </a-spin>
            </a-row>
        </div>
        <div v-else>
            <a-row>
                <a-col :span="4">
                    <a-button type="primary" @click="()=>{this.tab = 'map'}">
                        地图模式
                    </a-button>
                </a-col>
                <a-col :span="4">
                    <a-button type="primary" @click="()=>{this.tab = 'table'}">
                        列表模式
                    </a-button>
                </a-col>
            </a-row>
            <div class="body" v-if="tab === 'map'">
                <baidu-map class="map"
                           :center="center"
                           :zoom="14"
                           :scroll-wheel-zoom="true">
                    <bm-marker v-for="row in data.data"
                               :key="row.id"
                               @click="lookMap(row)"
                               :position="row.device">
                        <bm-label :content="row.carNo"
                                  :offset="{width: 0, height: 30}"/>
                    </bm-marker>
                </baidu-map>
            </div>
            <div class="body" v-if="tab === 'table'">
                <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
                    <template slot="operation" slot-scope="text,row">
                        <a style="padding-left:5px;" @click="lookMap(row)">查看轨迹</a>
                    </template>
                </a-table>
                <my-page :data="data" @change="onChange"/>
            </div>
        </div>

    </div>
</template>

<script>
    import {grtMonitorCarDisList, grtMonitorCarTraList} from './js/ApiMonitor';
    import {getNowDateString} from '../../config/Config';
    import notification from 'ant-design-vue/es/notification';

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '车牌号',
            dataIndex: 'carNo',
            key: 'carNo',
            ellipsis: true,
        },
        {
            title: '车辆型号',
            dataIndex: 'type',
            key: 'type',
            ellipsis: true,
        },
        {
            title: '品牌',
            dataIndex: 'brand',
            key: 'brand',
            ellipsis: true,
        },
        {
            title: '描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '100px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    const columnsChildren = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            width: '15%',
            align: 'center',
            ellipsis: true,
        },
        {
            title: '医废种类',
            dataIndex: 'name',
            key: 'name',
            width: '40%',
            align: 'center',
            ellipsis: true,
        },
        {
            title: '毛重',
            dataIndex: 'grossWeight',
            key: 'grossWeight',
            width: '15%',
            align: 'center',
            ellipsis: true,
        },
        {
            title: '皮重',
            dataIndex: 'tareWeight',
            key: 'tareWeight',
            width: '15%',
            align: 'center',
            ellipsis: true,
        },
        {
            title: '净重',
            dataIndex: 'netWeight',
            key: 'netWeight',
            width: '15%',
            align: 'center',
            ellipsis: true,
        },
    ];
    export default {
        data() {
            return {
                columns,
                columnsChildren,
                tab: 'map',
                lineIcon: {},
                showMap: false,
                // 轨迹
                trajectory: {},
                startDt: getNowDateString(),
                endDt: getNowDateString(),
                data: {},
                center: {},
                trCenter: {},
                // 只显示有定位的车
                carMap: [],
                spinning: false,
            }
        },
        methods: {
            // 选择日期后，点击查询数据
            selectData() {
                this.spinning = true;
                if (this.startDt && this.endDt) {
                    let baseDto = {
                        queryStartDate: this.startDt,
                        queryEndDate: this.endDt
                    };
                    grtMonitorCarTraList({id: this.trajectory.id, baseDto: baseDto}).then(res => {
                        this.trajectory = res.data.data;
                        this.trCenter = this.trajectory.device;
                        this.spinning = false;
                    })
                } else {
                    notification.error({
                        message: '查询时间不能为空',
                    });
                    this.spinning = false;
                }
            },
            // 查看轨迹
            lookMap(row) {
                this.spinning = true;
                if (row.device) {
                    this.showMap = !this.showMap;
                    let baseDto = {
                        queryStartDate: this.startDt,
                        queryEndDate: this.endDt
                    };
                    grtMonitorCarTraList({id: row.id, baseDto: baseDto}).then(res => {
                        this.trajectory = res.data.data;
                        this.trCenter = row.device;
                        this.spinning = false;
                    })
                } else {
                    notification.error({
                        message: '没有定位信息',
                    });
                    this.spinning = false;
                }
            },
            goBack() {
                this.showMap = !this.showMap;
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                grtMonitorCarDisList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
        },
        created() {
            grtMonitorCarDisList({}).then(res => {
                this.data = res.data;
                if (this.data.data[0].device) {
                    this.center = this.data.data[0].device;
                }
            })
        }
    }
</script>

<style scoped>
    .body {
        height: 100%;
        width: 100%;
    }

    .map {
        width: 100%;
        height: 85vh;
    }

    .count {
        width: 95%;
        height: 54vh;
        margin: 5px;
        overflow: auto;
    }

    .dv {
        width: 100%;
        overflow: auto;
        border-top-left-radius: 30px;
        border-bottom-right-radius: 30px;
    }
</style>
